module.exports = __webpack_public_path__ + "static/media/sell-online.71eb527f.jpg";